// src/ui/floating.js — where a floating window may sit, and how it parks.
//
// 🟥 THIS WAS INSIDE GroupCallDock, AND THE 1-ON-1 DOCK NEEDED EXACTLY IT. Two
//    copies of "keep the window on screen and snap it to an edge" is two sets of
//    off-by-ones, and the way they drift is always the same: one of them gets a
//    fix for a window that half-vanished on a small screen and the other does
//    not. The group dock still owns its resize and its layouts — those are its
//    own — but the geometry both windows share lives here once.

export const MARGIN = 18;
export const SNAP = 26;

export const vw = () => (typeof window === 'undefined' ? 1280 : window.innerWidth);
export const vh = () => (typeof window === 'undefined' ? 800 : window.innerHeight);

export function readJSON(key, fallback) {
  try {
    const v = JSON.parse(localStorage.getItem(key) || 'null');
    return v && typeof v === 'object' ? { ...fallback, ...v } : fallback;
  } catch { return fallback; }
}
export function writeJSON(key, v) {
  try { localStorage.setItem(key, JSON.stringify(v)); } catch { /* private mode */ }
}

/**
 * 🟥 POSITION AND SIZE ARE CLAMPED SEPARATELY, and `w`/`h` always mean the size
 *    of the OPEN window — never a minimised pill's. Clamping them together let
 *    minimising overwrite the stored size with the pill's, so restoring gave back
 *    a window the size of the pill it came from, permanently.
 *
 * 🟢 `null` means "never moved" — park it bottom-right, where it has always been.
 */
export function clampPos(x, y, w, h) {
  const maxX = Math.max(MARGIN, vw() - w - MARGIN);
  const maxY = Math.max(MARGIN, vh() - h - MARGIN);
  const px = x == null ? maxX : x;
  const py = y == null ? maxY : y;
  return { x: Math.max(MARGIN, Math.min(px, maxX)), y: Math.max(MARGIN, Math.min(py, maxY)) };
}

/**
 * 🧲 Released near an edge, it sits flush against it. Parking a call window by
 *    eye is fiddly and the result is always a few pixels off; this makes "put it
 *    in the corner" a gesture rather than a task.
 */
export function snapPos(x, y, w, h) {
  let nx = x;
  let ny = y;
  if (nx <= MARGIN + SNAP) nx = MARGIN;
  else if (nx + w >= vw() - MARGIN - SNAP) nx = vw() - w - MARGIN;
  if (ny <= MARGIN + SNAP) ny = MARGIN;
  else if (ny + h >= vh() - MARGIN - SNAP) ny = vh() - h - MARGIN;
  return clampPos(nx, ny, w, h);
}

/**
 * Drag a floating box by its header.
 *
 * 🟥 A CONTROL INSIDE THE HEADER IS A CONTROL, NOT A HANDLE — without this, the
 *    hang-up button becomes a place to grab the window and the call never ends.
 */
export function startDrag(e, { getBox, w, h, onMove, onEnd }) {
  if (e.target.closest && e.target.closest('button')) return false;
  e.preventDefault();
  const startX = e.clientX;
  const startY = e.clientY;
  const base = getBox();
  const move = (ev) => onMove(clampPos(base.x + (ev.clientX - startX), base.y + (ev.clientY - startY), w, h));
  const up = () => {
    window.removeEventListener('pointermove', move);
    window.removeEventListener('pointerup', up);
    onEnd?.();
  };
  window.addEventListener('pointermove', move);
  window.addEventListener('pointerup', up);
  return true;
}
